<template>
    <div>
        <el-form ref="form"
                 :model="form"
                 label-width="100px"
                 @submit.prevent.native="onSubmit">
            <el-row :gutter="30">
                <el-col :span="19">
                    <div class="box">
                        <div class="box__header">
                            <span class="box__header--text">{{ getRouteName($route) }}</span>
                            <form-language-switcher></form-language-switcher>
                        </div>
                        <el-form-item label="Nazwa"
                                      :error="errors[addLanguageSuffix('name')]"
                                      required>
                            <el-input v-model="form[addLanguageSuffix('name')]"/>
                        </el-form-item>
                        <el-form-item label="Opis strony (dla: google, facebook)"
                                      :error="errors[addLanguageSuffix('meta_description')]">
                            <el-input v-model="form[addLanguageSuffix('meta_description')]"/>
                        </el-form-item>
                        <el-form-item label="Popup" :error="errors['popup']">
                            <el-select v-model="form.popup"
                                       filterable
                                       clearable
                                       placeholder="Wybierz popup">
                                <el-option
                                        v-for="item in popups"
                                        :key="item.id"
                                        :label="item.working_name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <div>
                            <div class="box__header">
                                <span class="box__header--text">Widgety - widoczne w szczegółach:</span>
                            </div>
                            <widgets-input :widgets.sync="form.widgets"
                                           :lessDetails="true"
                                           :errors="errors.widgets || []"/>
                        </div>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="box">
                        <div class="box__header">
                            {{ $t('manage') }}
                        </div>
                        <el-form-item class="form__buttons" label-width="0">
                            <router-link :to="redirectRoute">
                                <el-button class="fluid form__button">{{ $t('cancel') }}</el-button>
                            </router-link>
                            <el-button @click="onSubmit"
                                       type="primary"
                                       class="fluid form__button"
                                       :loading="loading">
                                {{ $t('submit') }}
                            </el-button>
                            <label>
                                Ukryj
                                <el-switch v-model="form.hide"/>
                            </label>
                        </el-form-item>
                    </div>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>
    import WidgetsInput from '@/components/widgets/WidgetsInput'
    import {Popup, Page} from '@/api'

    export default {
        data () {
            return {
                loading: false,
                form: {
                    widgets: []
                },
                errors: {},
                loadingPopups: false,
                popups: [],
                service: Page,
                redirectRoute: {name: 'Pages List'}
            }
        },
        mounted () {
            this.fetchData()
        },
        components: {
            WidgetsInput
        },
        methods: {
            fetchData () {
                if (this.$route.params.slug) {
                    this.service.get({slug: this.$route.params.slug}).then(response => {
                        this.form = response.data
                    })
                }
                this.fetchPopups()
            },
            fetchPopups () {
                Popup.all().then(response => {
                    this.popups = response.data
                })
            },
            onSubmit () {
                this.loading = true;
                const slug = this.$route.params.slug
                const payload = {...this.form}
                const service = slug ? this.service.update({slug: slug}, payload) : this.service.save(payload)
                service
                    .then(this.successHandler)
                    .catch(this.errorHandler)
            }
        }
    }
</script>
<style lang="scss" scoped>
    .box__header {
        &--photos {
            margin-top: 40px;
        }
    }
</style>



// WEBPACK FOOTER //
// PageForm.vue?6dc47f39